import React from 'react';
import { TileLayer } from 'react-leaflet';

const TileLayerCustom = () => {
    const layerType = process.env.REACT_APP_CARTO_TYPE ? process.env.REACT_APP_CARTO_TYPE : ""
    switch (layerType) {
        case 'OPENSTREETMAP': // classique
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='&copy; <a class="mapTiles-link" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
                    maxZoom={24}
                />
            );
        case 'CARTOVOYAGER': // epuré jaune
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='&copy; <a class="mapTiles-link" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                    subdomains={['a', 'b', 'c', 'd']}
                    maxZoom={24}
                />
            );
        case 'CARTOLIGHT': // épuré gris & noir
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='&copy; <a class="mapTiles-link" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                    subdomains={['a', 'b', 'c', 'd']}
                    maxZoom={24}
                />
            );
        case 'ESRIGRAY': // super épuré gris et noir
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
                    maxZoom={24}
                />
            );
        case 'POSITRON': // super épuré gris et noir ligne prononcé
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='&copy; <a class="mapTiles-link" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                    subdomains={['a', 'b', 'c', 'd']}
                    maxZoom={24}
                />


            );
        case 'OPENSTREETMAPHOT': // léger épuré
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='&copy; <a class="mapTiles-link" href="http://openstreetmap.org">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                    subdomains={['a', 'b', 'c']}
                    maxZoom={24}
                />
            );
        case 'ESRISTREET':  // épurée jaune et orange
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC'
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                    maxZoom={24}
                />
            );
        case 'DBVOYAGE':  // épurée jaune et orange
            return (
                <TileLayer
                    className="mapTiles"
                      url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                    attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors &copy; <a href='https://carto.com/attributions'>CARTO</a>"
                    subdomains={['a', 'b', 'c']}
                    maxZoom={24}
                />
            );
        default:  // default
            return (
                <TileLayer
                    className="mapTiles"
                    attribution='&copy; <a class="mapTiles-link" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    maxZoom={24}
                />
            );
    }
};

export default TileLayerCustom;
